import { render, staticRenderFns } from "./Retirements.vue?vue&type=template&id=d205a298&scoped=true"
import script from "./Retirements.vue?vue&type=script&lang=js"
export * from "./Retirements.vue?vue&type=script&lang=js"
import style0 from "./Retirements.vue?vue&type=style&index=0&id=d205a298&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d205a298",
  null
  
)

export default component.exports